import axios from "axios";
import React, {Component} from "react";
import Register from "./Register";
import LoginGoogle from "./LoginGoogle";
import ReactLoading from "react-loading";

class Login extends Component{

    state = {
        username : "",
        password : "",
        error : "",
        registe : false,
        click : false,
        checked : true,
    }
    componentDidMount(){
        window.localStorage.clear();
    }
    
    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            click : false
        });
    }

    createRegister = () =>{
        this.setState({ registe : !this.state.registe})
    }

    getLogin  = () => {

        this.setState({
            click : true,
            error : ""
        })
         axios.post("login", {
            username: this.state.username,
            password: this.state.password
        }).then((login) => {
            localStorage.setItem("user", JSON.stringify(login.data.data));
            localStorage.setItem("society", JSON.stringify(login.data.society ? login.data.society : {}) );
            localStorage.setItem("permissions", JSON.stringify(login.data.permissions ? login.data.permissions : []) );
            window.location.replace(process.env.REACT_APP_BEYEGROUP);
        }).catch((error) => {
            window.localStorage.clear();
            this.setState({
                click : false,
                error: error?.response?.data.msg,
            });
        });
        
    }
    
    render(){
        if(this.state.registe) {
            return(
                 <Register />
            )
        }

        if(!this.state.registe) {
            return(
                <div id="body" className="auth-page" style={{backgroundImage: "url('img/background.png')", backgroundSize: "cover", backgroundPosition: "center center"}}>
            {/* Log In page */}
                <div className="container-md">
                    <div className="row vh-100 d-flex justify-content-center p-0">
                        <div className="col-12 align-self-center p-0">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-4 mx-auto">
                                        <div className="card mb-4 rounded rounded-3 border-white shadow">
                                             
                                            <div className="card-body pt-0">                                    
                                                <form className="my-4">
                                                    {this.state.error && (<div className="alert alert-danger text-center text-danger py-1 px-2 text-small">{this.state.error}</div>)}            
                                                    <div className="form-group mb-2">
                                                        <label className="form-label" htmlFor="username">Email</label>
                                                        <input type="text" className="form-control" id="username" name="username" onChange={this.handleInput}  placeholder="" />                               
                                                    </div>{/*end form-group*/} 
                        
                                                    <div className="form-group">
                                                        <label className="form-label" htmlFor="userpassword">Mot de passe</label>                                            
                                                        <input type="password" className="form-control" name="password"  onChange={this.handleInput}   id="userpassword" placeholder="" />                            
                                                    </div>{/*end form-group*/} 
                        
                                                    <div className="form-group row mt-3">
                                                        <div className="col">
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" style={{ backgroundColor : "red"}} checked={this.state.checked} onClick={ () => this.setState({ checked : !this.state.checked })} type="checkbox" id="customSwitchSuccess" />
                                                                <label className="form-check-label" htmlFor="customSwitchSuccess">Se souvenir de moi</label>
                                                            </div>
                                                        </div>{/*end col*/} 
                                                        {/* <div className="col-sm-6 text-end">
                                                            <a href="/resetpassword" className="text-muted font-13"><i className="dripicons-lock"></i> Mot de passe oublier?</a>                                    
                                                        </div> */}
                                                    </div> {/*end form-group*/} 

                                                    <div className="form-group mb-0 row">
                                                        <div className="col-12">
                                                            <div className="d-grid mt-3">
                                                            
                                                                <button className="btn text-white" style={{ backgroundColor : 'red'}} type="button" onClick={ () => this.getLogin() }>Connexion { !this.state.click ? <i className="bi bi-lock font-20 ms-1"></i> : <ReactLoading type="spokes"  className="float-end text-orangered" height={15} width={15} />}</button>
                                                            
                                                            </div>
                                                        </div>{/*end col*/} 
                                                    </div>
                                                    
                                                    <div className="mt-2 text-center d-none">
                                                        <LoginGoogle />
                                                    </div>                       
                                                </form>{/*end form*/}
                                                <div className="m-3 text-center text-muted">
                                                    <p className="mb-0">Vous n'avez pas un compte ?  
                                                    {/* <a href="#"  className="text-primary ms-2" onClick={() => this.createRegister()}>Créer un compte</a> */}
                                                    </p>
                                                </div>
                                                <hr className="hr-dashed mt-4" />
                                                <div className="text-center mt-n5">
                                                    <h6 className="card-bg px-3 my-4  text-primary d-inline-block" type="button" onClick={() => this.createRegister()}>Créer un compte</h6>
                                                    {/* <h6 className="card-bg px-3 my-4 d-inline-block">Connectez vous avec</h6> */}
                                                </div>
                                            </div>{/*end card-body*/}
                                        </div>{/*end card*/}
                                    </div>{/*end col*/}
                                </div>{/*end row*/}
                            </div>{/*end card-body*/}
                        </div>{/*end col*/}
                    </div>{/*end row*/}
                </div>{/*end container*/}  
            </div>
            )
        }
    }
}
export default Login